import * as React from 'react';
import './styles.sass';

export interface ISessionEditorToggleProps {
  onToggle: () => void;
}

export const SessionEditorToggle: React.StatelessComponent<ISessionEditorToggleProps>
  = ({onToggle}: ISessionEditorToggleProps) => (
    <span className={'session-editor-toggle'} onClick={onToggle}>
      <span className={'fa fa-bars icon'} />
    </span>
  );
